
import { Link } from "react-router-dom";
import Footer from "../components/footer";
import Header from "../components/header";
import PageHeader from "../components/pageHeader";
import SideNav from "../components/sidenav";
import React, { useEffect, useState } from "react";
import CountUp from 'react-countup';

const LandingArtist = () => {
    
    let userInfo = JSON.parse(localStorage.getItem('admin-info'));
    const [data, setData] = useState(null);
    const [recentsale, setRecentsale] = useState(null);

    useEffect(() => {
        fetch("https://igapi.heuristticminds.com/api/ProductList/Get-GetLatestArtworkByArtistID?artistID="+userInfo.user_id).then((result) => {
            result.json().then((resp) => {
                setData(resp);
            })
        })
    }, [])

    useEffect(() => {
        fetch("https://igapi.heuristticminds.com/api/OrderList/Get-GetRecentSaleDetailsByArtistID?artist_ID="+userInfo.user_id).then((result) => {
            result.json().then((resp) => {
                setRecentsale(resp);
            })
        })
    }, [])

    return (
        <>
            <Header />
            <div id="layoutSidenav">
                <SideNav />
                <div id="layoutSidenav_content">
                    <div>
                        <PageHeader name='Dashboard' icon='bi bi-activity' />
                        <div className="container-xl px-4">
                            <div className="row">
                                <div className="col-sm-3">
                                    <div className="card mb-3 bg1">
                                        <Link className="link_style1">
                                            <div className="card-body">
                                                <label className="mb-2">My Artwork for Sale</label>
                                                <h2><i className="bi bi-images me-3"></i><b><CountUp delay={0.1} end={2450} duration={0.8} /></b></h2>
                                                <i className="link bi bi-arrow-right-square-fill"></i>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className="card mb-3 bg2">
                                        <Link className="link_style1">
                                            <div className="card-body">
                                                <label className="mb-2">My Wishlist</label>
                                                <h2><i className="bi bi-suit-heart-fill me-3"></i><b><CountUp delay={0.1} end={2450} duration={0.8} /></b></h2>
                                                <i className="link bi bi-arrow-right-square-fill"></i>
                                            </div>
                                        </Link>
                                    </div>

                                </div>
                                <div className="col-sm-3">
                                    <div className="card mb-3 bg3">
                                        <Link className="link_style1">
                                            <div className="card-body">
                                                <label className="mb-2">My Orders</label>
                                                <h2><i className="bi bi-cart-check-fill me-3"></i><b><CountUp delay={0.1} end={2450} duration={0.8} /></b></h2>
                                                <i className="link bi bi-arrow-right-square-fill"></i>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className="card mb-3 bg4">
                                        <Link className="link_style1">
                                            <div className="card-body">
                                                <label className="mb-2">Contacts</label>
                                                <h2><i className="bi bi-person-rolodex me-3"></i><b><CountUp delay={0.1} end={450} duration={1} /></b></h2>
                                                <i className="link bi bi-arrow-right-square-fill"></i>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-6 mb-4">
                                    <div className="card mb-4 h-100">
                                        <div className="card-header">My Latest Artwork</div>
                                        <div className="card-body">
                                            <div className="ps-2 pe-2">
                                                {
                                                    data ? (
                                                        data.map((item) =>
                                                            <div className="latest_art">
                                                                <div className="latest_artimg"><img src={`../images/products/full/${item.image}`} alt=" " width="150px" /></div>
                                                                <div>
                                                                <div className="latest_art_title">{item.productTitle}</div>
                                                                    
                                                                    <div className="latest_art_p"><span>Status</span>{item.statusName}</div>
                                                                    {/* <div className="latest_art_p"><span>Uploaded</span>{item.createdOn}</div> */}
                                                                    <div className="latest_art_p"><span>Uploaded</span>{(new Date(item.createdOn)).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}</div>
                                                                    <div className="latest_art_p"><span>Price</span>{item.price}</div>
                                                                </div>
                                                            </div>
                                                        )
                                                    ) : (
                                                        <div className="text-center m-5">
                                                            <div className="spinner-border text-secondary" role="status">
                                                                <span className="visually-hidden">Loading...</span>
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 mb-4">
                                    <div className="card mb-4 h-100">
                                        <div className="card-header">Recent Sale</div>
                                        <div className="card-body">
                                            <div className="ps-2 pe-2">
                                                {
                                                    recentsale ? (
                                                        recentsale.map((item) =>
                                                            <div className="latest_art">
                                                                <div className="latest_artimg"><img src={`../images/products/full/${item.imageURL}`} alt=" " width="150px" /></div>
                                                                <div>
                                                                    <div className="latest_art_title">{item.productName}</div>
                                                                    <div className="latest_art_p"><span>Buyer</span>{item.buyerName}</div>
                                                                    <div className="latest_art_p"><span>Email</span>{item.email}</div>
                                                                    <div className="latest_art_p"><span>Mobile</span>{item.mobile}</div>
                                                                    <div className="latest_art_p"><span>Price</span>{item.amount}</div>
                                                                    <div className="latest_art_p"><span>Sale on</span>{(new Date(item.createdOn)).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}</div>
                                                                    
                                                                </div>
                                                            </div>
                                                        )
                                                    ) : (
                                                        <div className="text-center m-5">
                                                            <div className="spinner-border text-secondary" role="status">
                                                                <span className="visually-hidden">Loading...</span>
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </>
    );
};

export default LandingArtist;